<div class="main-container">

  <div class="title">
    <span class="title-text">Requisition Queue</span>
    <p class="small-title">Lock and provision requisitions end to end.</p>
  </div>

  <div class="searchBar">
    <div class="each-div small">
      <span class="drop-title">Mode</span>
      <mat-form-field appearance="outline">
        <mat-select [formControl]="requisitionMode">
          @for(m of modes; track m){ <mat-option [value]="m">{{ m }}</mat-option> }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="each-div small">
      <span class="drop-title">Category</span>
      <mat-form-field appearance="outline">
        <mat-select [formControl]="requisitionCategory">
          @for(c of categories; track c){ <mat-option [value]="c">{{ c }}</mat-option> }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="each-div small">
      <span class="drop-title">Type</span>
      <mat-form-field appearance="outline">
        <mat-select [formControl]="requisitionType">
          @for(t of types; track t){ <mat-option [value]="t">{{ t }}</mat-option> }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="each-div small">
      <span class="drop-title">From Date</span>
      <input type="date" class="text-box-active" [formControl]="requisitionFromDate" />
    </div>
    <div class="btn">
      <button type="button" class="ac-primary-btn" (click)="search()">Search</button>
      @if(canProvision){
      <button type="button" class="ac-secondary-btn" (click)="lockOldest()">Lock oldest</button>
      }
      @if(canRollback){
      <button type="button" class="ac-secondary-btn" (click)="rollbackAll()">Rollback aged locks</button>
      }
    </div>
  </div>

  @if(counts){
  <div class="count-cards">
    <div class="count-card">
      <span class="count-label">Regular · Rooms</span>
      <span class="count-value">{{ counts.regularRoom }}</span>
      <span class="count-sub">open, next {{ countsWindowDays }} days</span>
    </div>
    <div class="count-card">
      <span class="count-label">Regular · Dormitory</span>
      <span class="count-value">{{ counts.regularDorm }}</span>
      <span class="count-sub">open, next {{ countsWindowDays }} days</span>
    </div>
    <div class="count-card">
      <span class="count-label">Utsav · Rooms</span>
      <span class="count-value">{{ counts.utsavRoom }}</span>
      <span class="count-sub">open, next {{ countsWindowDays }} days</span>
    </div>
    <div class="count-card">
      <span class="count-label">Utsav · Dormitory</span>
      <span class="count-value">{{ counts.utsavDorm }}</span>
      <span class="count-sub">open, next {{ countsWindowDays }} days</span>
    </div>
    <div class="count-card">
      <span class="count-label">Admin queue</span>
      <span class="count-value">{{ counts.adminOpen }}</span>
      <span class="count-sub">forwarded, still open</span>
    </div>
    <div class="count-card">
      <span class="count-label">Pending cancellations</span>
      <span class="count-value">{{ counts.adminPendingCancel }}</span>
      <span class="count-sub">confirmed, sent for cancel</span>
    </div>
    <div class="count-card">
      <span class="count-label">Exception eligible</span>
      <span class="count-value">{{ counts.exceptionEligible }}</span>
      <span class="count-sub">open, next {{ countsWindowDays }} days</span>
    </div>
  </div>
  }

  @if(hasSearched){
  <div class="queue-narrow">
    <div class="status-tabs">
      @for(t of statusTabs; track t.key){
      <button type="button" class="status-tab" [class.active]="statusTab === t.key" (click)="setTab(t.key)">
        {{ t.label }} ({{ tabCount(t.key) }})
      </button>
      }
    </div>
    <input
      type="text"
      class="text-box-active keyword-input"
      placeholder="Search booking id, family code, type"
      [(ngModel)]="keyword"
      (input)="onKeywordChange()"
    />
  </div>
  }

  <div class="table-container">
    <table class="table">
      <thead class="table-head">
        <tr>
          <th>Booking ID</th>
          <th>Family Code</th>
          <th>Category</th>
          <th>Type</th>
          <th>Mode</th>
          <th>Guests</th>
          <th>From</th>
          <th>To</th>
          <th>Status</th>
          <th>Stage</th>
          @if(hasActions){ <th>Actions</th> }
        </tr>
      </thead>
      <tbody class="table-body">
        @for(row of pagedResults; track row.requisitionId){
        <tr>
          <td>{{ row.requisitionId }}</td>
          <td>{{ row.familyCode }}</td>
          <td>{{ row.requisitionCategory || '-' }}</td>
          <td>{{ row.requisitionType || '-' }}</td>
          <td>{{ row.requisitionMode || '-' }}</td>
          <td>{{ row.requisitionGuestCount }}</td>
          <td>{{ row.requisitionFromDate }}</td>
          <td>{{ row.requisitionToDate }}</td>
          <td>{{ row.requisitionStatus }}</td>
          <td>{{ row.requisitionLifecycleStatus }}</td>
          @if(hasActions){
          <td class="actions-cell">
            @if(showProvision(row)){ <button type="button" class="ac-secondary-small-btn" (click)="provision(row)">Provision</button> }
            @if(showRollback(row)){ <button type="button" class="ac-secondary-small-btn" (click)="rollback(row)">Rollback</button> }
            @if(showCancel(row)){ <button type="button" class="ac-secondary-small-btn" (click)="cancel(row)">Cancel</button> }
            @if(showForward(row)){ <button type="button" class="ac-secondary-small-btn" (click)="forward(row)">Forward</button> }
            @if(showForwardCancel(row)){ <button type="button" class="ac-secondary-small-btn" (click)="forwardCancel(row)">Forward cancel</button> }
            @if(awaitingCancel(row)){ <span class="muted-note">Sent for cancellation</span> }
          </td>
          }
        </tr>
        }
        @if(hasSearched && filteredResults.length === 0){
        <tr>
          <td [attr.colspan]="hasActions ? 11 : 10" class="empty-row">No requisitions match this view.</td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  @if(filteredResults.length > pageSize){
  <div class="pager">
    <button type="button" class="ac-secondary-small-btn pager-btn" [disabled]="page === 1" (click)="prevPage()">Previous</button>
    <span class="pager-info">Page {{ page }} of {{ totalPages }} · {{ filteredResults.length }} rows</span>
    <button type="button" class="ac-secondary-small-btn pager-btn" [disabled]="page === totalPages" (click)="nextPage()">Next</button>
  </div>
  }

</div>

<app-loader [isLoading]="isLoading"></app-loader>
